/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Invite_Code_TitleInputs */

const en_common_sign_invite_code_title = /** @type {(inputs: Common_Sign_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code`)
};

/**
* | output |
* | --- |
* | "Invite code" |
*
* @param {Common_Sign_Invite_Code_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_invite_code_title = /** @type {((inputs?: Common_Sign_Invite_Code_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Invite_Code_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_invite_code_title(inputs)
});
export { common_sign_invite_code_title as "common.sign.invite_code_title" }